export default __webpack_public_path__ + "static/media/DTEX-UC3-Seq2-WOEDashboard-Filled.514967e4.png";